import React from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { Table } from "components/bootstrap";
import { Section } from "components/common";
import FeatureModelRow from "./FeatureModelRow";
const GroupSection = styled(Section)`
  background-color: ${({ theme }) => theme.colors.global.contentBackground};
  margin-bottom: ${({ theme }) => theme.spacings.md};
`;
const FeatureCount = styled.span`
  color: ${({ theme }) => theme.colors.text.secondary};
  font-size: ${({ theme }) => theme.fonts.size.small};
  font-weight: normal;
`;
const FeaturesTable = styled(Table)`
  margin-bottom: 0;
`;
const FeatureCountLabel = ({ count }) => {
  const { t } = useTranslation("enterprise_ai");
  return /* @__PURE__ */ React.createElement(FeatureCount, null, t("feature_model_group.feature_count", { count }));
};
const FeatureModelGroup = ({ name, features, providers }) => {
  const { t } = useTranslation("enterprise_ai");
  return /* @__PURE__ */ React.createElement(
    GroupSection,
    {
      title: name,
      titleAs: "h2",
      collapsible: true,
      headerLeftSection: /* @__PURE__ */ React.createElement(FeatureCountLabel, { count: features.length })
    },
    /* @__PURE__ */ React.createElement(FeaturesTable, { condensed: true, responsive: true }, /* @__PURE__ */ React.createElement("thead", null, /* @__PURE__ */ React.createElement("tr", null, /* @__PURE__ */ React.createElement("th", null, t("feature_model_group.table.feature")), /* @__PURE__ */ React.createElement("th", null, t("feature_model_group.table.provider")), /* @__PURE__ */ React.createElement("th", null, t("feature_model_group.table.model")))), /* @__PURE__ */ React.createElement("tbody", null, features.map((feature) => /* @__PURE__ */ React.createElement(FeatureModelRow, { key: feature.feature_id, feature, providers }))))
  );
};
export default FeatureModelGroup;
